import { Box, Button, HStack, Modal, Text } from 'native-base';
import React from 'react';
import { useMHRDischargeModal } from '../hooks/useMHRDischargeModal';
import Loading from '../../Common/components/Loading';
import MHRDocumentViewer from './MHRDocumentViewer';
import { useMHRDocumentAttachmentModal } from '../hooks/useDocumentAttachmentModal';

interface IDoctorMHRDischargeModalProps {
  customerID: string;
  onLoadDocumentCLicked: (documentID: string, repositoryID: string | null | undefined) => void;
}
export function DoctorMHRDischargeModal({ customerID, onLoadDocumentCLicked }: IDoctorMHRDischargeModalProps) {
  const [attachmentFileName, setAttachmentFileName] = React.useState<string | null>(null);

  const { loading, error, ok, html, documentId, uniqueRepositoryId } = useMHRDischargeModal(customerID);

  const { loading: loadingAttachment, error: errorAttachment, ok: okAttachment, html: htmlAttachment } = useMHRDocumentAttachmentModal(customerID, documentId, uniqueRepositoryId, attachmentFileName);

  const loadAttachment = (attachmentFileName: string) => {
    const oidRegex = /^\d+(\.\d+){2,}\.html$/i;
    if (oidRegex.test(attachmentFileName)) {
      const documentID = attachmentFileName.replace(/\.html$/, '');
      onLoadDocumentCLicked(documentID, uniqueRepositoryId);
    }
    else {
      setAttachmentFileName(attachmentFileName);
    }
  };

  const onBackClicked = () => {
    setAttachmentFileName(null);
  }

  return (
    <Modal.Content>
      <Modal.CloseButton />
      <Modal.Header>
        <HStack alignItems="center" justifyContent="space-between" width="100%" pr={12}>
          <Text fontSize="md" fontWeight="bold">MHR Latest Discharge Summary View</Text>
          {attachmentFileName && <Button onPress={() => onBackClicked()} variant="ghost" size="sm">
            Back to Discharge View
          </Button>}
        </HStack>
      </Modal.Header>

      <Modal.Body h={620}>
        {loading && <Loading />}

        {!loading && !loadingAttachment && !attachmentFileName && (
          <Box h={600} flex={1}>
            {ok && html && <MHRDocumentViewer content={html} metadata={{ title: "Medicare Overview", typeCode: "" }} onLinkClicked={loadAttachment}/>}
            {ok && !html && <Text>No Discharge Summary Available. More information may exist in this patient's clinical documents list.</Text>}
            {error && <Text>{error}</Text>}
          </Box>
        )}
        {okAttachment && attachmentFileName && (
          <Box h={600} flex={1}>
            {okAttachment && htmlAttachment && <MHRDocumentViewer content={htmlAttachment} metadata={{ title: "Medicare Overview", typeCode: "" }} onLinkClicked={loadAttachment}/>}
            {okAttachment && !htmlAttachment && <Text>The referenced attachment has no content to display.</Text>}
            {errorAttachment && <Text>{errorAttachment}</Text>}
          </Box>
        )}
      </Modal.Body>
    </Modal.Content>
  );
}
